const pin_r = 8;
const head = 8;
const point_load_arrow_head = 8;
const distLoadArrowShaft = 35;
const point_load_arrow_shaft = 60;
var dist_load_arrow_shaft = 35;
const moment_radius = 20;
const dimension_tick = 10;

var wsOrange = invertColor("#0d86d7"); //#f27928

function invertColor(x) {
  var t1 = '0123456789abcdef#', t2 = 'fedcba9876543210#';
  x = x.replace(/./gi, function (s) { return t2.charAt(t1.indexOf(s)); });
  return x;
}

var selectedColor = wsOrange; //inverse of a nice blue
export var selectedAttribute = { fill: selectedColor };

export const spanAttribute = {
  gradient: '90-#A11500-#D14221', //steel
  stroke: '#3b4449',
  'stroke-width': 2,
  'stroke-linejoin': 'round'
}

const supportAttribute = {
  gradient: '90-#636363-#999999',
  stroke: '#3b4449',
  'stroke-width': 2,
  'stroke-linejoin': 'round'
}

const freeSupportAttr = {
  gradient: '90-#636363-#999999',
  stroke: '#3b4449',
  'stroke-width': 2,
  'stroke-linejoin': 'round',
  opacity: 0.4
}

var point_load_attr = {
  stroke: '#3b4449',
  'stroke-width': 5
}

const distLoadArrowAttr = {
  stroke: '#3b4449',
  'stroke-width': 2,
  'stroke-linejoin': 'round'
}

const distLoadRectAttr = {
  stroke: '#3b4449',
  'stroke-width': 2,
  fill : '#FAE284',
  opacity:0.75
}

const labelRectAttr = {
  fill : '#ffffff',
  'fill-opacity': 0.6,
  'stroke-linejoin': 'round'
}

export function drawBeamSpan(x1, x2, y1, y2, dimensionText, paper, onclick) {
  const y = y1
  const t = y2 - y1
  const L = x2 - x1

  const beamRect = paper.rect(x1, y, L, t)
  beamRect.attr(spanAttribute)
  setSelectable(beamRect, spanAttribute, selectedAttribute)
  beamRect.node.onclick = onclick
  drawSpanDimension(x1, x2, y1, y2, dimensionText, beamRect, paper, onclick)
  return beamRect
}

function drawSpanDimension(x1, x2, y1, y2, label, element, paper, onclick) {
  var x = x1
  var y = y1
  var t = y2 - y1
  var L = x2 - x1

  const st = paper.set()
  st.push(drawLine(x, y + 3.0 * t, x + L, y + 3.0 * t, paper))
  st.push(drawLine(x, y + 2.5 * t, x, y + 3.5 * t, paper))
  st.push(drawLine(x + L, y + 2.5 * t, x + L, y + 3.5 * t, paper))
  var l = paper.text(x + L / 2, y + 3.5 * t, label)
  st.push(l)
  l.attr("font-size", "14")
  l.node.onclick = onclick
  l.node.onmouseover = () => {
    element.attr(selectedAttribute)
    l.node.style.cursor = 'pointer'
    l.attr("fill", "#0d86d7")
  }
  l.node.onmouseout = () => {
    element.attr(spanAttribute)
    l.attr("fill", "#000000");
  }
  return st
}

export function drawSupport(type, x, y, t, myCanvas, onclick) {
  if (type.match(/pinned/)) return drawSimpleSupport(x, y, myCanvas, onclick);
  else if (type.match(/roller/)) return drawRollerSupport(x, y, myCanvas, onclick);
  else if (type.match(/fixed/)) return drawFixedSupport(x, y, t, myCanvas, onclick);
  else return drawFreeSupport(x, y, t, myCanvas, onclick);
}

function drawSimpleSupport(x, y, myCanvas, onclick) {
  var tri = drawTriangle(pin_r * 2, x, y, myCanvas)
  tri.attr(supportAttribute)
  setSelectable(tri, supportAttribute, selectedAttribute)
  tri.node.onclick = onclick
  //label
  var l = myCanvas.text(x, y + 26, "Pinned")
  l.attr("font-size", "12")
  setSelectableTrigger(l, tri, supportAttribute, { stroke: selectedColor })
  l.node.onclick = onclick
  l.toFront()
  l.node.onmouseover = () => {
    tri.attr(selectedAttribute)
    l.node.style.cursor = 'pointer'
    l.attr("fill", "#0d86d7")
  }
  l.node.onmouseout = () => {
    tri.attr(supportAttribute)
    l.attr("fill", "#000000")
  }
  return tri
}

function drawRollerSupport(x, y, myCanvas, onclick) {
  var c = myCanvas.circle(x, y + pin_r, pin_r)
  c.attr(supportAttribute)
  setSelectable(c, supportAttribute, selectedAttribute);
  c.node.onclick = onclick
  return c
}

function drawFreeSupport(x, y, t, myCanvas, onclick) {
  var r = myCanvas.rect(x - 0.25 * pin_r, y - t, 0.5 * pin_r, t);
  r.attr(freeSupportAttr);
  setSelectable(r, freeSupportAttr, selectedAttribute);
  r.node.onclick = onclick
  //label
  var l = myCanvas.text(x, y + 26, "Free");
  l.attr("font-size", "12");
  setSelectableTrigger(l, r, supportAttribute, { stroke: selectedColor });
  l.node.onclick = onclick
  l.toFront()
  l.node.onmouseover = () => {
    r.attr(selectedAttribute);
    l.node.style.cursor = 'pointer';
    l.attr("fill", "#0d86d7");
  };
  l.node.onmouseout = () => {
    r.attr(freeSupportAttr);
    l.attr("fill", "#000000");
  };
  return r;
}

function drawFixedSupport(x, y, t, myCanvas, onclick) {
  var r = myCanvas.rect(x - pin_r, y - pin_r - t, 2 * pin_r, 2 * pin_r + t);
  r.attr(supportAttribute);
  setSelectable(r, supportAttribute, selectedAttribute);
  r.node.onclick = onclick
  //label
  var l = myCanvas.text(x, y + 26, "Fixed");
  l.attr("font-size", "12");
  setSelectableTrigger(l, r, supportAttribute, { stroke: selectedColor });
  l.node.onclick = onclick
  l.toFront();
  l.node.onmouseover = function () {
    r.attr(selectedAttribute);
    l.node.style.cursor = 'pointer';
    l.attr("fill", "#0d86d7");
  };
  l.node.onmouseout = function () {
    r.attr(supportAttribute);
    l.attr("fill", "#000000");
  };
  return r;
}

export function drawPointLoad(direction, x, y, label, myCanvas, onclick) {
  var a = null
  if (direction == "up") {
    a = drawUpArrow(x, y, point_load_arrow_shaft, myCanvas)
  } else {
    a = drawDownArrow(x, y, point_load_arrow_shaft, myCanvas)
  }
  a.attr(point_load_attr)
  setSelectable(a, point_load_attr, { stroke: selectedColor })
  a.node.onclick = onclick
  //our label
  let l = myCanvas.text(x, y - point_load_arrow_shaft - 12, label);
  l.attr("font-size", "12");
  setSelectableTrigger(l, a, point_load_attr, { stroke: selectedColor })
  l.node.onclick = onclick
  l.toFront();
  return l;
}

function drawForceReaction(direction, x, y, label, dimLabel, myCanvas) {
  var a = null, l = null;
  if (direction == "up") {
    a = drawUpArrow(x, y + point_load_arrow_shaft + point_load_arrow_head, point_load_arrow_shaft, myCanvas);
    l = myCanvas.text(x, y + point_load_arrow_shaft + head + 12, label);
  } else {
    a = drawDownArrow(x, y - point_load_arrow_head, point_load_arrow_shaft, myCanvas);
    l = myCanvas.text(x, y - point_load_arrow_shaft - head - 12, label);
  }
  a.attr(point_load_attr);
  l.attr("font-size", "12");
  l.toFront();
  return [a, l];
}

export function drawMomentLoad(x, y, t, label, myCanvas, onclick) {
  const a = drawMomentArrow(x, y + t / 2, moment_radius, myCanvas)
  a.attr(point_load_attr)
  setSelectable(a, point_load_attr, { stroke: selectedColor })
  a.node.onclick = onclick
  //our label
  var l = myCanvas.text(x + 36, y + t + 24 - 8, label);
  l.attr("font-size", "12");
  setSelectableTrigger(l, a, point_load_attr, { stroke: selectedColor })
  l.node.onclick = onclick
  l.toFront();
  return l;
}

function drawMomentReaction(x, y, t, label, myCanvas, dom_class_id) {
  var a = drawMomentArrow(x, y + t / 2, moment_radius, myCanvas), index = Number(dom_class_id.split("_")[1]);
  a.attr(point_load_attr);
  var l = myCanvas.text(x + 36, y + t + 24, label);
  l.attr("font-size", "12");
  l.toFront();
  return l;
}

function drawPointLoadDimension(xstart, xend, y, label, parentElem, myCanvas, onclick) {
  const L = xend
  drawLine(xstart, y, xend, y, myCanvas);
  drawLine(xstart, y - dimension_tick, xstart, y + dimension_tick, myCanvas);
  drawLine(xend, y - dimension_tick, xend, y + dimension_tick, myCanvas);

  var l = myCanvas.text(L / 2, y - 14, label);
  l.attr("font-size", "14");
  l.node.onclick = onclick
  l.node.onmouseover = function () {
    parentElem.attr({ stroke: selectedColor });
    this.style.cursor = 'pointer';
    l.attr("fill", "#0d86d7");
  };
  l.node.onmouseout = function () {
    parentElem.attr(point_load_attr);
    l.attr("fill", "#000000");
  };
}

export function drawLinearLoad(q1, q2, x1, x2, y1, y2, label, myCanvas, onclick) {
  var y = y1;
  var length = dist_load_arrow_shaft;
  var dist = x2 - x1;
  var labelX = x1 + dist / 2;
  var bbox = renderedTextSize(label, "12");
  bbox.width += 20;
  bbox.height *= 1.25;
  // draw at least 3 arrows but no more than 20
  // draw arrows every 12 inches
  var nArrows = Math.round(Math.max(Math.min(dist / 12.0, 12), 3));
  var delta = dist / (nArrows - 1);
  var h1 = length;
  var h2 = length;
  if (Math.abs(q2) > Math.abs(q1)) {
    h2 = length;
    h1 = q1 / q2 * length;
  } else {
    h1 = length;
    h2 = q2 / q1 * length;
  }
  var r = drawTrapazoid(x1, y1, x2, y2, h1, h2, myCanvas);
  r.attr(distLoadRectAttr);
  setSelectable(r, distLoadRectAttr, selectedAttribute);
  r.node.onclick = onclick
  var i = (q1 === 0.0 || q2 === 0.0) ? 1 : 0;
  for (i = 0; i < nArrows; i++) {
    var arrow_length = h1 - (h1 - h2) * i / (nArrows - 1);
    var a = drawDownArrow(x1 + i * delta, y, arrow_length, myCanvas);
    a.attr(distLoadArrowAttr);
    setSelectableTrigger(a, r, distLoadRectAttr, selectedAttribute);
    a.node.onclick = onclick
  }
  //our label
  var tokens = label.split(/\n/);
  var lines = tokens.length;

  var labelBoxY = y - length + 4;

  var r2 = myCanvas.rect(labelX - (bbox.width * 0.5), labelBoxY, bbox.width, bbox.height);
  r2.attr(labelRectAttr);

  var l = myCanvas.text(labelX, labelBoxY + 8, label);
  l.attr("font-size", "12");

  setSelectableTrigger(l, r, distLoadArrowAttr, selectedAttribute);
  l.node.onclick = function () { openLinearLoadDialog(loadIndex); };
  l.toFront();
  return l;
}


export function drawDistributedLoad(direction, x1, x2, y1, label, myCanvas, onclick) {
  const y = y1
  const length = distLoadArrowShaft
  const dist = x2 - x1
  const nArrows = Math.round(Math.max(Math.min(dist / 12.0, 12), 3))
  const delta = dist / (nArrows - 1)
  const r = myCanvas.rect(x1, y - length, dist, length)
  r.attr(distLoadRectAttr);
  setSelectable(r, distLoadRectAttr, selectedAttribute)
  r.node.onclick = onclick
  for (var i = 0; i < nArrows; i++) {
    var a = null
    if (direction === "up") {
      a = drawUpArrow(x1 + i * delta, y, length, myCanvas)
    } else {
      a = drawDownArrow(x1 + i * delta, y, length, myCanvas)
    } 
    a.attr(distLoadArrowAttr)
    setSelectableTrigger(a, r, distLoadRectAttr, selectedAttribute)
    a.node.onclick = onclick
  }
  //our label
  const bbox = renderedTextSize(label, "12")
  bbox.width += 20
  bbox.height *= 1.25

  const labelBoxY = y - length + 6

  const r2 = myCanvas.rect(x1 + dist / 2 - (bbox.width * 0.5), labelBoxY, bbox.width, bbox.height)
  r2.attr(labelRectAttr)
  
  const l = myCanvas.text(x1 + dist / 2, labelBoxY + 10, label)
  l.attr("font-size", "12")
  setSelectableTrigger(l, r, distLoadRectAttr, selectedAttribute)
  l.node.onclick = onclick
  l.toFront()
  return l
}


//highlight element when mouse is over element
function setSelectable(element, unselectAttribute, selectedAttribute) {
  element.node.onmouseover = () => {
    element.attr(selectedAttribute);
    element.node.style.cursor = 'pointer'
  }
  element.node.onmouseout = () => {
    element.attr(unselectAttribute);
  }
}

//hightlight the destination object when the mouse is over hover_elem
function setSelectableTrigger(hoverElem, destElem, unselectAttribute, selectedAttribute) {
  hoverElem.node.onmouseover = () => {
    destElem.attr(selectedAttribute)
    hoverElem.node.style.cursor = 'pointer'
  }
  hoverElem.node.onmouseout = () => {
    destElem.attr(unselectAttribute)
  }
}

function renderedTextSize(string, fontSize) {
  var paper = Raphael(0, 0, 0, 0);
  paper.canvas.style.visibility = 'hidden';

  var el = paper.text(0, 0, string);
  el.attr('font-size', fontSize);

  var bBox = el.getBBox();
  paper.remove();

  return {
    width: bBox.width,
    height: bBox.height
  };
}

function pathM(x, y) { return " M " + x + " " + y + " "; }

function pathL(x, y) { return " L " + x + " " + y + " "; }

function drawLine(x1, y1, x2, y2, myCanvas) {
  var pathStr = pathM(x1, y1) + pathL(x2, y2);
  var p = myCanvas.path(pathStr);
  return p;
}

function drawHorizontalDoubleArrow(x1, y1, x2, y2, head_size, myCanvas) {
  var half_tick = parseInt(head_size * 0.5);
  var pathStr = pathM(x1 + half_tick, y1 - half_tick);
  pathStr += pathL(x1, y1);
  pathStr += pathL(x1 + half_tick, y1 + half_tick);
  pathStr += pathM(x1, y1);
  pathStr += pathL(x2, y2);
  pathStr += pathL(x2 - half_tick, y2 - half_tick);
  pathStr += pathM(x2, y2);
  pathStr += pathL(x2 - half_tick, y2 + half_tick);
  var p = myCanvas.path(pathStr);
  return p;
}

function drawVerticalDoubleArrow(x1, y1, x2, y2, head_size, myCanvas) {
  var half_tick = parseInt(head_size * 0.5);
  var pathStr = pathM(x1 - half_tick, y1 + half_tick);
  pathStr += pathL(x1, y1);
  pathStr += pathL(x1 + half_tick, y1 + half_tick);
  pathStr += pathM(x1, y1);
  pathStr += pathL(x2, y2);
  pathStr += pathL(x2 - half_tick, y2 - half_tick);
  pathStr += pathM(x2, y2);
  pathStr += pathL(x2 + half_tick, y2 - half_tick);
  var p = myCanvas.path(pathStr);
  return p;
}

function drawMomentArrow(x, y, r, myCanvas) {
  var n_section = 15;
  var theta = 1.5 * 3.14159625 / n_section;
  var pathStr = pathM(0, r);
  var xr = 0;
  var yr = 0;
  for (var i = 0; i < n_section + 1; i++) {
    xr = r * Number(Math.sin(i * theta));
    yr = r * Number(Math.cos(i * theta));
    //alert( xr + " " + yr );
    pathStr += pathL(xr, yr);
  }
  //yr += head;
  pathStr += pathL(xr - head / 2, yr);
  pathStr += pathL(xr, yr + head);
  pathStr += pathL(xr + head / 2, yr);
  pathStr += pathL(xr, yr);
  //pathStr += " z";
  var p = myCanvas.path(pathStr);
  p.translate(x, y);
  return p;
}

function drawTriangle(size, x, y, myCanvas) {
  //M 0 size L size size L size/2 0 L 0 size z
  var pathStr = pathM(0, size) + pathL(size, size) + pathL(size / 2, 0) + pathL(0, size) + " z";
  var p = myCanvas.path(pathStr);
  p.translate(x - size / 2, y);
  return p;
}

function drawTrapazoid(x1, y1, x2, y2, q1, q2, myCanvas) {
  var pathStr = pathM(x1, y1 - q1) + pathL(x1, y1) + pathL(x2, y2) + pathL(x2, y2 - q2) + " z";
  var p = myCanvas.path(pathStr);
  return p;
}

function drawDownArrow(x, y, length, myCanvas) {
  // don't draw arrow head
  var pathStr = pathM(-head / 3, -head) + pathL(0, 0) + pathL(head / 3, -head) + pathL(0, 0) + pathL(0, -length);
  if (length < head * 1.2) {
    pathStr = pathM(0, 0) + pathL(0, -length);
  }
  var p = myCanvas.path(pathStr);
  p.translate(x, y);
  return p;
}

function drawUpArrow(x, y, length, myCanvas) {
  var pathStr = pathM(-head / 3, -length + head) + pathL(0, -length) + pathL(head / 3, -length + head) + pathL(0, -length) + pathL(0, 0);
  var p = myCanvas.path(pathStr);
  p.translate(x, y);
  return p;
}